import { InteractionType } from "@azure/msal-browser";

export class PCodeConfig
{
	static azureAd: PCodeConfigAzureAd =
		{
			enabled: false,
			tenantId: '',
			clientId: '',
			graphApiUrl: 'https://graph.microsoft.com/v1.0/',
			interactionType: InteractionType.Popup
		}

	static vapid: PCodeConfigVapid =
		{
			publicKey: 'BEiovEqn3jrei827SLUWdvK9y005aTBynrndrIyNMlVIL2XdukxeBLflwLmXIjY3YqdY4fMakNdedNkw9LkTR0E'
		}

	static google: PCodeConfigGoogle =
		{
			apiKey: 'AIzaSyDdzeKGpzpbcpSxAXm-qVzx0Pwk00qTAUs'
		}
}

interface PCodeConfigAzureAd
{
	enabled: boolean;
	tenantId: string;
	clientId: string;
	graphApiUrl: string;
	interactionType: InteractionType
}
interface PCodeConfigVapid
{
	publicKey: string;
}
interface PCodeConfigGoogle
{
	apiKey: string;
}